const DM_BASE_URI = "/api/DialogManager/";
export const GET_CUSTOMER_REQUISITION_URI = (id) =>
  `/api/CustomerRequisition/${id}`;
export const POST_CUSTOMER_REQUISITION_URI = "/api/CustomerRequisition/";
export const GET_VENDOR_REQUISITION_URI = (id) =>
  `/api/VendorRequisition/${id}`;
export const POST_VENDOR_REQUISITION_URI = "/api/VendorRequisition/";
export const POST_DIALOG_MANAGER_CAR_RETURN_URI = `${DM_BASE_URI}CarReturn/`;
export const POST_DIALOG_MANAGER_CAR_PICKUP_URI = `${DM_BASE_URI}CarPickup/`;
export const POST_DIALOG_MANAGER_CAR_NO_CHECK_URI = (licensePlateNo) =>
  `${DM_BASE_URI}VerifyCarLicensePlateNo/${licensePlateNo}`;
export const POST_REPAYMENT_URI = `${DM_BASE_URI}Repayment/`;

export const LOCALES = ["da", "en"];
export const INSURANCE_TYPES = [
  { id: "AIG", name: "AIG" },
  { id: "Alka", name: "Alka" },
  { id: "Alm_Brand", name: "Alm. Brand" },
  {
    id: "Chubb_Insurance_Company_of_Euro",
    name: "Chubb Insurance Company of Euro",
  },
  { id: "Codan", name: "Codan" },
  { id: "Danske_Forsikringsskade", name: "Danske Forsikringsskade" },
  { id: "Etu_Forsikring_A_S", name: "Etu Forsikring A/S" },
  { id: "Euro_Insurances_Limited", name: "Euro Insurances Limited" },
  { id: "Frederiksborg_Brand", name: "Frederiksborg Brand" },
  { id: "Gartnernes_Forsikring", name: "Gartnernes Forsikring" },
  { id: "GF_Forsikring", name: "GF-Forsikring" },
  { id: "Gjensidige", name: "Gjensidige" },
  { id: "IF", name: "IF" },
  { id: "Kommunernes_Gensidige", name: "Kommunernes Gensidige" },
  { id: "Kobstadernes", name: "Købstædernes" },
  { id: "Lloyds", name: "Lloyds" },
  { id: "NORDforsikring", name: "NORDforsikring" },
  { id: "Nykredit_Ostifterne", name: "Nykredit Østifterne" },
  { id: "Oplyses_af_leasingtager", name: "Oplyses af leasingtager" },
  { id: "Popermo", name: "Popermo" },
  { id: "Privatsikring", name: "Privatsikring" },
  { id: "Rasmussen_Assurance", name: "Rasmussen Assurance" },
  { id: "Topdanmark", name: "Topdanmark" },
  { id: "Tryg", name: "Tryg" },
  {
    id: "Udflytternes_Forsikringsselskab",
    name: "Udflytternes Forsikringsselskab",
  },
  { id: "XL_insurence", name: "XL insurence" },
  { id: "Zurich_Danmark", name: "Zurich Danmark" },
  { id: "Protector_Forsikring", name: "Protector Forsikring" },
  { id: "Global_Forsikring_Argentur_APS", name: "Global Forsikring Argentur APS" },
  { id: "HDI_Danmark", name: "HDI Danmark" },
  { id: "AXA_Forsiking", name: "AXA Forsiking" },
  { id: "Sønderjysk_Forsikring", name: "Sønderjysk Forsikring" },
  { id: "Greenval_Insurance_DAC_Arval", name: "Greenval Insurance DAC - Arval" },
];

export const CONSENT_TYPES = [
  { id: "true", name: "Yes" },
  { id: "false", name: "No" },
];
